import { z } from "zod";
import {
  createGetListRequestSchema,
  DomainModelMetaExtendedSchema,
  DomainModelMetaSchema,
  DomainModelSchema,
} from "../util/index.ts";

export const CommentEntity = {
  ASSET: "asset",
  REPORT: "report",
  WORKFLOW: "workflow",
} as const;
export type CommentEntityType =
  (typeof CommentEntity)[keyof typeof CommentEntity];

export const CommentFileSchema = z.object({
  comment_id: z.string().uuid(),
  file_id: z.string(),
  file_name: z.string().max(128),
  created_at: z.date().or(z.string().datetime()),
});
export type CommentFileSchemaType = z.infer<typeof CommentFileSchema>;

export const CommentSchema = z
  .object({
    company_id: z.string().uuid(),
    text: z.string().max(5120),
    title_context: z.string().max(64).optional(),
    is_deleted: z.boolean().default(false),
    commented_at: z.date().or(z.string().datetime()),
    entity_type: z.enum([
      CommentEntity.ASSET,
      CommentEntity.REPORT,
      CommentEntity.WORKFLOW,
    ]),
    entity_id: z.string().uuid(),
    additional_identifier: z
      .string()
      .optional()
      .describe(
        "Used to group comments by an additional context e.g. a workflow task"
      ),
    files: z.array(CommentFileSchema),
    user: z.object({ id: z.string().uuid(), name: z.string() }),
  })
  .merge(DomainModelSchema)
  .merge(DomainModelMetaSchema)
  .merge(DomainModelMetaExtendedSchema)
  .describe("Represents a Comment in the Node API");
export type CommentSchemaType = z.infer<typeof CommentSchema>;

export const CommentSchemaGetListRequestSchema = createGetListRequestSchema(
  z
    .object({
      id: z.string(),
      created_before: z.string(),
      additional_identifier: z.string(),
    })
    .partial()
);
export type CommentSchemaGetListRequestType = z.infer<
  typeof CommentSchemaGetListRequestSchema
>;

export const CommentFormSchema = z
  .object({
    files: z.array(
      z.object({
        ref: z.string(),
        name: z.string(),
      })
    ),
  })
  .merge(CommentSchema.pick({ text: true }));
export type CommentFormType = z.infer<typeof CommentFormSchema>;
